import React, { useState } from "react";
import { Button } from "reactstrap";
import SearchTagRefresh from "../../../core/form/searchtagrefresh";
import VisibleColumnToggler from "../../../helper/visibleColumnToggler";
import DesktopBreakpoint from "../../../context/desktop_breakpoint";
import PhoneBreakpoint from "../../../context/phone_breakpoint";

const DomainUserHeader = props => {
  const [showSearchBoxForMobile, handleSearchBoxForMobileView] = useState(
    false
  );

  return (
    <div className="d-flex contentHeader">
      <div className="mr-auto">
        {(props.currentUserRolesDUH.includes("SuperAdmin") ||
          props.editDUH) && (
          <Button
            className="primaryButton primaryButton--contentHeader"
            onClick={() => props.handleAddUserDUH(true)}
            type="button"
          >
            <i className="fa fa-plus mr-2" />
            <DesktopBreakpoint>Add User</DesktopBreakpoint>
            <PhoneBreakpoint>Add</PhoneBreakpoint>
          </Button>
        )}
      </div>
      <PhoneBreakpoint>
        <div
          role="presentation"
          className="contentHeader__searchContainer"
          onClick={() => handleSearchBoxForMobileView(true)}
        >
          <i className=" bx bx-search bx-sm " />
        </div>
      </PhoneBreakpoint>
      <div
        className={`searchContaainerForMobile ${showSearchBoxForMobile &&
          "expandedSearch"}`}
      >
        <div className="d-flex flex-row-reverse full-width-search">
          <SearchTagRefresh
            handleSearch={props.handleSearchValueDUH}
            placeholder="Search by Name"
            searchVal={props.searchValDUH}
            {...props}
          />
          <PhoneBreakpoint>
            <div
              role="presentation"
              className="closeSearchContainer"
              onClick={() => handleSearchBoxForMobileView(false)}
            >
              <i className="mr-0 fa fa-times " />
            </div>
          </PhoneBreakpoint>
        </div>
      </div>
      <VisibleColumnToggler
        hiddenColumns={props.hiddenColumns}
        toggleHiddenColumns={props.toggleHiddenColumns}
        columnToggleProps={props.columnToggleProps}
      />
    </div>
  );
};

export default DomainUserHeader;
